import React, { Fragment, useState } from "react";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { CSSTransition } from "react-transition-group";

import ThemeToggler from "./ThemeToggler";
import { logout } from "../actions/auth";

const Header = (props) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { siteTitle, logout } = props;
  const authLinks = (
    <Fragment>
      <Link className="mx-5" to="/account">
        Account
      </Link>
      <button onClick={() => logout()} className="mx-5">
        Sign Out
      </button>
    </Fragment>
  );
  const guestLinks = (
    <Link className="mx-5" to="/login">
      <button className="hover-up-sm rounded bg-indigo-700 text-white py-2 px-4 shadow-lg">
        Log In
      </button>
    </Link>
  );
  return (
    <header className="mb-2 px-4 py-2 flex items-center justify-between">
      <div className="flex-start">
        <h1 className="font-bold tracking-wide" style={{ margin: 0 }}>
          <Link
            to="/"
            style={{
              textDecoration: `none`,
            }}
          >
            {siteTitle}
          </Link>
        </h1>
      </div>
      <div>
        <button
          onClick={() => {
            setDropdownOpen(!dropdownOpen);
          }}
          className="sm:hidden"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="h-8 w-8 fill-current text-inverse"
          >
            <path
              className="secondary"
              fillRule="evenodd"
              d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
            />
          </svg>
        </button>
        <CSSTransition
          in={dropdownOpen}
          classNames="dropdown-menu"
          timeout={{ enter: 500, exit: 300 }}
        >
          <div
            className={
              dropdownOpen
                ? `sm:hidden absolute inset-0 m-5 p-8 bg-primary rounded shadow-2xl `
                : `hidden`
            }
          >
            <button
              onClick={() => {
                setDropdownOpen(!dropdownOpen);
              }}
              className="absolute top-0 right-0 m-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className="h-10 w-10 fill-current text-inverse "
              >
                <path
                  className="secondary"
                  fillRule="evenodd"
                  d="M15.78 14.36a1 1 0 0 1-1.42 1.42l-2.82-2.83-2.83 2.83a1 1 0 1 1-1.42-1.42l2.83-2.82L7.3 8.7a1 1 0 0 1 1.42-1.42l2.83 2.83 2.82-2.83a1 1 0 0 1 1.42 1.42l-2.83 2.83 2.83 2.82z"
                />
              </svg>
            </button>
            <div className="flex flex-col items-center mt-10 text-inverse">
              <Link
                onClick={() => {
                  setDropdownOpen(false);
                }}
                className="my-2 text-xl"
                to="stories"
              >
                Stories
              </Link>
              <Link
                onClick={() => {
                  setDropdownOpen(false);
                }}
                className="my-2 text-xl"
                to="login"
              >
                Log In
              </Link>
            </div>
          </div>
        </CSSTransition>
      </div>

      <div className="hidden mx-5 lg:mx-10 font-sans sm:flex items-center">
        <ThemeToggler></ThemeToggler>
        <Link className="mx-5 " to="/stories">
          Stories
        </Link>
        {props.auth.isAuthenticated ? authLinks : guestLinks}
      </div>
    </header>
  );
};

Header.propTypes = {
  siteTitle: PropTypes.string,
  auth: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
};

Header.defaultProps = {
  siteTitle: ``,
};

const mapStateToProps = (state) => ({ auth: state.auth });

export default connect(mapStateToProps, { logout })(Header);
